/**
 * Tiny i18n. Russian first, since that is the default for this deployment,
 * with English as the fallback for any key a translation is missing.
 *
 * Plurals go through Intl.PluralRules so Russian gets its one/few/many forms
 * right instead of the usual "1 участников".
 */

import { tr } from './i18n-tr.js'
import { kk } from './i18n-kk.js'

const ru = {
  'app.name': 'Pine',
  'app.tagline': 'Мессенджер без серверов',

  'nav.chats': 'Чаты',
  'nav.channels': 'Каналы',
  'nav.contacts': 'Контакты',
  'nav.settings': 'Настройки',

  'onboard.welcome': 'Добро пожаловать в Pine',
  'onboard.lede': 'Сообщения идут напрямую между устройствами. Ни аккаунтов, ни номера телефона, ни сервера, который хранит вашу переписку.',
  'onboard.create': 'Создать профиль',
  'onboard.restore': 'У меня есть ключ восстановления',
  'onboard.name': 'Как вас зовут?',
  'onboard.namePlaceholder': 'Имя или ник',
  'onboard.username': 'Выберите имя пользователя',
  'onboard.usernameLede': 'По нему вас найдут, не обмениваясь длинными ключами. Можно пропустить и задать позже.',
  'onboard.usernameSkip': 'Пропустить',
  'access.title': 'Осталось выдать разрешения',
  'access.lede': 'Android усыпляет приложения, которыми не пользуются. Без этих разрешений звонки и сообщения будут приходить только пока Pine открыт на экране.',
  'access.notifications': 'Уведомления',
  'access.notificationsWhy': 'Иначе о звонке и сообщении никто не сообщит',
  'access.battery': 'Работа в фоне',
  'access.batteryWhy': 'Исключение из экономии батареи — без него связь обрывается через несколько минут',
  'access.fullScreen': 'Звонок на весь экран',
  'access.fullScreenWhy': 'Чтобы входящий звонок показывался поверх блокировки',
  'access.allow': 'Разрешить',
  'access.done': 'Готово',
  'access.anyway': 'Продолжить без этого',
  'access.needNotifications': 'Без уведомлений дальше нельзя: иначе приложение не сможет сообщить вам о звонке.',
  'access.partial': 'Часть разрешений не выдана — звонки могут не доходить, когда приложение закрыто. Их можно выдать позже в настройках.',
  'onboard.continue': 'Продолжить',
  'onboard.keyTitle': 'Сохраните ключ восстановления',
  'onboard.keyLede': 'Это единственный способ вернуть профиль на другом устройстве. Восстановить его невозможно — сервера, который бы его хранил, не существует.',
  'onboard.keyCopied': 'Ключ скопирован',
  'onboard.keySaved': 'Я сохранил ключ',
  'onboard.restoreTitle': 'Восстановление профиля',
  'onboard.restoreLede': 'Введите ключ восстановления, который вы сохранили при создании профиля.',
  'onboard.restoreAction': 'Восстановить',
  'onboard.back': 'Назад',

  'chats.title': 'Чаты',
  'chats.search': 'Поиск',
  'chats.empty': 'Пока пусто',
  'chats.emptyHint': 'Создайте группу, канал или начните личный чат по Pine ID.',
  'chats.all': 'Все',
  'chats.unread': 'Непрочитанные',
  'chats.groups': 'Группы',
  'chats.channels': 'Каналы',
  'chats.direct': 'Личные',
  'chats.archived': 'Архив',
  'chats.saved': 'Избранное',
  'restore.title': 'Переписка ещё не загружена',
  'link.addDevice': 'Войти по QR с другого устройства',
  'link.title': 'Вход по QR',
  'link.lede': 'Откройте Pine на устройстве, где вы уже вошли: Настройки → Устройства → Добавить устройство. Отсканируйте этот код.',
  'link.orCode': 'Или скопируйте код и вставьте его там:',
  'link.waiting': 'Ждём подтверждения…',
  'link.expired': 'Время вышло. Попробуйте ещё раз.',
  'devices.title': 'Устройства',
  'devices.empty': 'Пока только это устройство.',
  'devices.unnamed': 'Устройство',
  'devices.current': 'это устройство',
  'devices.revoke': 'Отвязать',
  'devices.revoked': 'Устройство отвязано',
  'devices.add': 'Добавить устройство',
  'devices.addHint': 'Отсканируйте QR с нового устройства',
  'devices.addAction': 'Продолжить',
  'devices.scanLede': 'Наведите камеру на QR, который показывает новое устройство.',
  'devices.pasteLabel': 'Или вставьте код с того устройства',
  'devices.linked': 'Устройство добавлено',
  'devices.linking': 'Передаём…',
  'devices.confirmTitle': 'Передать аккаунт этому устройству?',
  'devices.confirmBody': 'Оно получит полный доступ к вашему аккаунту и всей переписке. Делайте это, только если устройство ваше и код показано именно оно.',
  'devices.confirmAction': 'Передать',
  'devices.warning': 'Отвязка убирает устройство из списка, и честный клиент выходит из аккаунта. Но ключ аккаунта у него уже есть — если устройство в чужих руках, надёжно помогает только новый аккаунт.',
  'restore.action': 'Восстановить',
  'restore.asking': 'Запрашиваем у участников…',
  'restore.asked': 'Запрос отправлен: {n}',
  'restore.nobodyOnline': 'Никого из участников нет в сети. Попробуйте позже.',
  'restore.hint': 'Название и состав восстановлены с сервера. Переписку отдадут сами участники.',
  'restore.section': 'Восстановление',
  'restore.sectionHint': 'Запросить у участников то, чего нет на этом устройстве: историю или право писать.',
  'restore.nothingMissing': 'Чат уже полностью восстановлен',
  'attach.title': 'Прикрепить',
  'attach.media': 'Фото и видео',
  'attach.music': 'Музыка',
  'attach.documents': 'Документы',
  'attach.files': 'Файлы',
  'attach.poll': 'Опрос',
  'attach.unreadable': 'Не удалось прочитать файлов: {n}',
  'attach.pickerFailed': 'Не удалось открыть выбор файлов',
  'poll.title': 'Новый опрос',
  'poll.question': 'Вопрос',
  'poll.questionPlaceholder': 'О чём спрашиваем?',
  'poll.options': 'Варианты ответа',
  'poll.optionPlaceholder': 'Вариант',
  'poll.optionMore': 'Добавить вариант',
  'poll.optionsHint': 'Новая строка появляется сама. Enter — перейти к следующей.',
  'poll.limit': 'Больше вариантов добавить нельзя.',
  'poll.anonymous': 'Анонимное голосование',
  'poll.multiple': 'Несколько ответов',
  'poll.anonymousNote': 'Анонимный опрос',
  'poll.noVotes': 'Пока никто не проголосовал',
  'poll.create': 'Создать',
  'chats.you': 'Вы',
  'chats.draft': 'Черновик',

  'new.title': 'Новый чат',
  'new.group': 'Группа',
  'new.groupHint': 'Общий чат, где пишут все',
  'new.channel': 'Канал',
  'new.channelHint': 'Публикуют администраторы, остальные читают',
  'new.direct': 'Личный чат',
  'new.directHint': 'Один на один по Pine ID',
  'new.join': 'Присоединиться по ссылке',
  'new.joinHint': 'Вставьте приглашение',
  'new.name': 'Название',
  'new.namePlaceholder': 'Например, Команда Pine',
  'new.description': 'Описание',
  'new.create': 'Создать',
  'new.peerId': 'Pine ID собеседника',
  'new.start': 'Начать',
  'new.invitePlaceholder': 'https://papi.olshub.xyz/i/… или код',

  'conv.placeholder': 'Сообщение',
  'conv.placeholderChannel': 'Написать в канал',
  'conv.readOnly': 'Здесь могут писать только администраторы',
  'conv.notWritable': 'Ждём подтверждения доступа к комнате…',
  'conv.askAccess': 'Запросить снова',
  'conv.queueing': 'Чат ещё подтверждает это устройство. Пишите: сообщения уйдут, как только кто-то из участников будет в сети.',
  'settings.contactDev': 'Написать разработчику',
  'settings.contactDevHint': 'Вопросы, ошибки, предложения',
  'contactDev.lede': 'Вопросы, ошибки и предложения — на почту разработчику:',
  'contactDev.copy': 'Скопировать адрес',
  'contactDev.write': 'Написать письмо',
  'stories.mute': 'Выключить звук',
  'stories.unmute': 'Включить звук',
  'conv.sending': 'Отправляется…',
  'bot.label': 'бот',
  'bot.start': 'Начать',
  'bot.commands': 'Команды бота',
  'bot.addToGroup': 'Добавить в группу',
  'bot.addTitle': 'Добавить {name} в группу',
  'bot.add': 'Добавить',
  'bot.added': 'Приглашение в «{name}» отправлено',
  'bot.addFailed': 'Не дошло: получатель сейчас не в сети. Можно отправить ссылку-приглашение.',
  'bot.noGroups': 'Нет групп, куда вы можете пригласить',
  'assistant.subtitle': 'ИИ-помощник',
  'assistant.denied': 'Чтобы использовать ИИ-помощника, обратитесь к разработчику.',
  'assistant.copyId': 'Скопировать мой Pine ID',
  'assistant.idCopied': 'Pine ID скопирован — отправьте его разработчику',
  'assistant.connecting': 'Аня подключается — чат заработает через несколько секунд.',
  'action.send': 'Отправить',
  'stories.me': 'Я',
  'stories.mine': 'Моя история',
  'stories.add': 'Добавить историю',
  'stories.title': 'Новая история',
  'stories.caption': 'Подпись — необязательно',
  'stories.publish': 'Опубликовать',
  'stories.published': 'История опубликована на 24 часа',
  'stories.failed': 'Не удалось опубликовать',
  'stories.audience': 'Историю увидят все, с кем у вас есть личный чат. Через 24 часа она исчезнет. Сервер Pine хранит её только в зашифрованном виде.',
  'stories.tooBig': 'Слишком большой файл: для истории — до 24 МБ',
  'stories.tooLong': 'Видео для истории — не длиннее минуты',
  'stories.unsupported': 'В историю можно добавить фото или видео',
  'stories.unreadable': 'Не получилось открыть это фото',
  'stories.reply': 'Ответить…',
  'stories.sent': 'Отправлено в личный чат',
  'stories.play': 'Продолжить',
  'stories.pause': 'Пауза',
  'stories.gone': 'Эта история больше недоступна',
  'stories.viewsTitle': 'Просмотры: {n}',
  'stories.noViews': 'Пока никто не смотрел',
  'stories.delete': 'Удалить',
  'stories.deleteConfirm': 'Удалить эту историю у всех?',
  'stories.deleted': 'История удалена',
  'stories.replyHeader': 'Ответ на историю',
  'stories.reactedHeader': 'Реакция на историю',
  'badge.bot': 'Бот',
  'contacts.inviteTo': 'приглашает в «{name}»',
  'conv.empty': 'Здесь пока нет сообщений',
  'conv.emptyHint': 'Напишите первое — оно уйдёт напрямую участникам.',
  'conv.awaitingPeer': 'Приглашение отправляется. {name} увидит чат, когда откроет Pine — можно писать уже сейчас.',
  'conv.thatPerson': 'Собеседник',
  'conv.selectChat': 'Выберите чат',
  'conv.selectChatHint': 'Или начните новый кнопкой «+» над списком чатов.',
  'chats.noMessages': 'Сообщений пока нет',
  'conv.edited': 'изменено',
  'conv.deleted': 'Сообщение удалено',
  'conv.attachmentGone': 'Файл больше никто не раздаёт',
  'media.loading': 'Загружается…',
  'media.waiting': 'Придёт, когда отправитель будет в сети',
  'media.tapToLoad': 'Нажмите, чтобы загрузить',
  'invite.group': 'Приглашение в группу',
  'invite.channel': 'Приглашение в канал',
  'invite.unnamed': 'Без названия',
  'invite.join': 'Вступить',
  'invite.subscribe': 'Подписаться',
  'collect.title': 'Коллекционное имя',
  'collect.kind': 'Выпущено оператором Pine · не истекает',
  'collect.explain': 'Имя станет вашим именем пользователя. Его не нужно продлевать, и больше его никто не получит.',
  'collect.replaces': 'Ваше текущее имя {name} освободится.',
  'collect.take': 'Забрать имя',
  'collect.done': 'Теперь вы — {name}',
  'collect.err.used': 'Эту ссылку уже использовали.',
  'collect.err.unknown': 'Ссылка недействительна или сервер имён недоступен.',
  'collect.err.taken': 'Это имя уже занято.',
  'collect.err.frozen': 'Аккаунт заморожен и не может получить имя.',
  'collect.err.offline': 'Нет связи с сервером имён. Попробуйте позже.',
  'collect.err.failed': 'Не удалось забрать имя.',
  'settings.linkPreviews': 'Превью ссылок',
  'settings.linkPreviewsHint': 'Заголовок и картинка ссылки в сообщении. Страницу загружает сервер Pine — он узнаёт адрес ссылки, но не чат и не получателя.',
  'conv.reply': 'Ответить',
  'conv.edit': 'Изменить',
  'conv.delete': 'Удалить',
  'conv.copy': 'Копировать текст',
  'conv.forward': 'Переслать',
  'conv.pin': 'Закрепить',
  'conv.unpin': 'Открепить',
  'conv.replyTo': 'Ответ',
  'conv.editing': 'Редактирование',
  'conv.pinned': 'Закреплённое',
  'conv.jumpToLatest': 'К последним',
  'conv.loadOlder': 'Показать более ранние',
  'conv.deleteConfirm': 'Удалить сообщение у всех?',
  'conv.deleteForAll': 'Удалить у всех',
  'conv.cancel': 'Отмена',
  'conv.typing': 'печатает…',
  'conv.typingMany': 'печатают…',
  'conv.online': 'в сети',
  'conv.membersOnline': '{online} в сети',
  'conv.recording': 'Запись голосового',
  'emoji.search': 'Поиск эмодзи',
  'emoji.none': 'Ничего не нашлось',
  'emoji.cat.recent': 'Недавние',
  'emoji.cat.smileys': 'Смайлы и эмоции',
  'emoji.cat.people': 'Люди и жесты',
  'emoji.cat.nature': 'Животные и природа',
  'emoji.cat.food': 'Еда и напитки',
  'emoji.cat.travel': 'Путешествия и места',
  'emoji.cat.activities': 'Занятия',
  'emoji.cat.objects': 'Предметы',
  'emoji.cat.symbols': 'Символы',
  'conv.slideToCancel': 'Отпустите, чтобы отправить',

  // Without a gendered verb: "присоединился" read wrong for half the people
  // it was said about — Anya among them.
  'sys.join': '{name} теперь в чате',
  'sys.leave': '{name} больше не в чате',
  'sys.kick': '{name} удалён из чата',
  'sys.role': '{name} теперь {role}',
  'sys.callEnded': 'Звонок, {duration}',
  'sys.callMissed': 'Пропущенный звонок',
  'sys.callNoAnswer': 'Звонок без ответа',
  'sys.callDeclined': 'Звонок отклонён',

  'panel.info': 'Информация',
  'panel.members': 'Участники',
  'panel.media': 'Медиа',
  'panel.files': 'Файлы',
  'panel.links': 'Ссылки',
  'panel.invite': 'Пригласить',
  'panel.inviteLink': 'Ссылка-приглашение',
  'panel.newInvite': 'Создать ссылку',
  'panel.copyLink': 'Скопировать ссылку',
  'panel.revoke': 'Отозвать',
  'panel.notifications': 'Уведомления',
  'panel.mute': 'Без звука',
  'panel.pinChat': 'Закрепить чат',
  'panel.archive': 'В архив',
  'panel.leave': 'Покинуть чат',
  'panel.leaveConfirm': 'Выйти из чата? История останется на устройстве.',
  'panel.permissions': 'Права',
  'panel.readOnly': 'Только чтение',
  'panel.membersCanInvite': 'Участники могут приглашать',
  'panel.reactions': 'Реакции',
  'panel.disappearing': 'Исчезающие сообщения',
  'panel.noMedia': 'Медиа пока нет',
  'panel.makeAdmin': 'Назначить администратором',
  'panel.makeModerator': 'Назначить модератором',
  'panel.makeMember': 'Сделать участником',
  'panel.removeMember': 'Удалить из чата',
  'panel.copyId': 'Скопировать Pine ID',

  'role.owner': 'Владелец',
  'role.admin': 'Администратор',
  'role.moderator': 'Модератор',
  'role.member': 'Участник',
  'role.restricted': 'Ограничен',

  'frozen.title': 'Аккаунт заморожен.',
  'frozen.body': 'Администрация ограничила его: создавать новые чаты и вступать в новые нельзя, найти вас тоже нельзя. Все существующие чаты работают как обычно.',
  'frozen.self': 'Аккаунт заморожен: новые чаты создавать нельзя. Существующие работают.',
  'frozen.peer': 'Этот аккаунт заморожен — начать с ним новый чат нельзя.',

  'report.title': 'Пожаловаться',
  'report.action': 'Пожаловаться',
  'report.user': 'Пожаловаться на пользователя',
  'report.userSub': 'Переписка уйдёт в поддержку',
  'report.reason': 'Причина',
  'report.reason.spam': 'Спам',
  'report.reason.abuse': 'Оскорбления и угрозы',
  'report.reason.fraud': 'Мошенничество',
  'report.reason.illegal': 'Запрещённый контент',
  'report.reason.other': 'Другое',
  'report.note': 'Что случилось',
  'report.notePlaceholder': 'Необязательно, но помогает разобраться',
  'report.send': 'Отправить жалобу',
  'report.sent': 'Жалоба отправлена',
  'report.failed': 'Не удалось отправить жалобу. Попробуйте позже.',
  'report.sendsMessage': 'На сервер уйдёт это сообщение, ваш Pine ID и причина — и больше ничего.',
  'report.sendsChat': 'На сервер уйдут последние 100 сообщений этого чата открытым текстом: их прочитает администрация. Обычно переписку в Pine не видит никто, кроме собеседников, — это единственное исключение, и оно происходит только по вашей кнопке.',

  'settings.title': 'Настройки',
  'settings.profile': 'Профиль',
  'avatar.change': 'Сменить фото',
  'avatar.remove': 'Убрать фото',
  'avatar.updated': 'Фото обновлено',
  'avatar.failed': 'Не удалось обработать изображение',
  'avatar.notImage': 'Это не изображение',
  'badge.verified': 'Проверенный аккаунт',
  'badge.tester': 'Бета-тестер',
  'badge.donor': 'Поддержал проект',
  'badge.translator': 'Переводчик',
  'settings.badges': 'Значки',
  'settings.badgeAlways': 'Всегда виден',
  'settings.badgesHint': 'Значки видны другим рядом с вашим именем. Выдаёт их администрация. Скрыть можно любой, кроме «Проверенного аккаунта»: он нужен, чтобы никто не мог выдать себя за вас.',
  'settings.badgeFailed': 'Не удалось сохранить — сервер недоступен',
  'settings.badgeRefused': 'Не получилось сохранить: сервер отклонил запрос',
  'settings.name': 'Имя',
  'settings.bio': 'О себе',
  'settings.username': 'Имя пользователя',
  'settings.usernameHint': 'Люди смогут найти вас по @имени вместо длинного ID.',
  'settings.usernamePlaceholder': 'например, alexey',
  'settings.usernameFree': 'Имя объявлено в сети',
  'settings.usernameNone': 'Не задано',
  'name.err.emoji': 'Эмодзи в имени не поддерживаются',
  'username.err.short': 'Минимум 3 символа',
  'username.err.long': 'Максимум 32 символа',
  'username.err.charset': 'Только латиница, цифры и подчёркивание',
  'username.err.underscore': 'Не может начинаться или заканчиваться подчёркиванием',
  'username.err.empty': 'Введите имя',
  'username.err.taken': 'Имя уже занято — попробуйте другое',
  'username.err.offline': 'Сервер имён недоступен. Попробуйте позже.',
  'username.err.failed': 'Не удалось занять имя',
  'username.err.stale': 'Часы устройства сбиты — проверьте время',
  'username.err.slow_down': 'Слишком много попыток. Подождите минуту.',
  'settings.usernameTaken': 'Занято',
  'settings.usernameChecking': 'Проверяем…',
  'settings.usernameReserved': 'Имя закреплено за вами',
  'search.byUsername': 'Поиск по @имени или Pine ID',
  'search.searching': 'Ищем…',
  'search.notFound': 'Никто не отвечает на это имя. Возможно, человек не в сети.',
  'search.found': 'Найдено',
  'search.collision': 'Это имя объявили несколько человек. Сверьте ID.',
  'search.hint': 'Имя закрепляется за одним человеком. Если сервер имён недоступен, поиск идёт напрямую по сети и может найти нескольких.',
  'contacts.username': 'Имя пользователя',
  'settings.yourId': 'Ваш Pine ID',
  'settings.idHint': 'Дайте его тем, кто хочет вам написать.',
  'settings.appearance': 'Оформление',
  'settings.theme': 'Тема',
  'settings.themeSystem': 'Как в системе',
  'settings.themeLight': 'Светлая',
  'settings.themeDark': 'Тёмная',
  'settings.language': 'Язык',
  'settings.notifications': 'Уведомления',
  'settings.notificationsGroup': 'Уведомления и звуки',
  'settings.chatsGroup': 'Чаты и медиа',
  'settings.keysGroup': 'Ключ и выход',
  'settings.notificationsCalls': 'Уведомления и звонки',
  'settings.chatsAppearance': 'Чаты и оформление',
  'settings.privacySecurity': 'Конфиденциальность и безопасность',
  'settings.bgAttention': 'Звонки могут не доходить: проверьте разрешения',
  'settings.notificationsOn': 'Показывать уведомления',
  'settings.sound': 'Звук',
  'settings.autostart': 'Запускать вместе с системой',
  'settings.autostartHint': 'Компьютер нельзя разбудить сигналом с сервера, как телефон: сообщения и звонки приходят, только пока Pine запущен. Он стартует в трей, без окна.',
  'settings.privacy': 'Приватность',
  'settings.readReceipts': 'Отчёты о прочтении',
  'settings.typingIndicators': 'Показывать, что я печатаю',
  'settings.enterToSend': 'Enter отправляет сообщение',
  'settings.autoDownload': 'Автозагрузка медиа',
  'settings.backupKeys': 'Резервная копия чатов',
  'settings.backupKeysHint': 'Ключи от чатов лежат на сервере зашифрованными — так чаты возвращаются сразу при входе на новом устройстве. Выключите, если предпочитаете спрашивать их у собеседников.',
  'settings.calls': 'Звонки',
  'settings.telecom': 'Системные звонки Android',
  'settings.telecomHint': 'Звонки идут через системную службу вызовов: приходят надёжнее, отвечают с гарнитуры и в машине. Выключите, если на вашем телефоне с ними что-то не так.',
  'pro.home': 'Больше моделей и лимитов у Ани',
  'pro.active': 'Активна до {date}',
  'pro.ended': 'Закончилась {date}',
  'pro.inactive': 'Не оформлена',
  'pro.unavailable': 'Сервер сейчас не отвечает, попробуйте позже',
  'pro.what': 'Что даёт подписка',
  'pro.plain': 'Обычный',
  'pro.perDay': 'Вопросов в день',
  'pro.perMonth': 'Вопросов в месяц',
  'pro.images': 'Картинок в день',
  'pro.models': 'Дополнительные модели',
  'pro.get': 'Оформить',
  'pro.extend': 'Продлить',
  'pro.howTo': 'Подписку оформляет разработчик. Нажмите кнопку: в письме уже будет ваш Pine ID. Разработчик ответит, как оплатить, и включит Pro.',
  'pro.contactLede': 'Напишите разработчику, что хотите оформить Pine AI Pro. Он ответит, как оплатить, и включит подписку для вашего Pine ID.',
  'pro.contactBody': 'Здравствуйте! Хочу оформить Pine AI Pro.',
  'settings.ringFromPush': 'Звонок сразу через сервер',
  'settings.ringFromPushHint': 'Телефон звонит, как только сервер передаст вызов, не дожидаясь соединения с собеседником. Сервер и Google при этом видят, кто вам звонит (только ID, без разговора).',
  'settings.ringtone': 'Рингтон',
  'settings.ringtonePine': 'Pine',
  'settings.ringtoneSystem': 'Как на устройстве',
  'settings.ringtonePick': 'Выбрать на устройстве…',
  'settings.background': 'Работа в фоне',
  'settings.backgroundHint': 'Звонки и сообщения приходят, только пока Pine работает в фоне. Если что-то из этого не разрешено, входящие могут не дойти.',
  'settings.push': 'Будить Pine, когда он закрыт',
  'settings.pushHint': 'Сервер присылает через Google пустой сигнал — «звонок» или «есть новое», — и Pine просыпается и забирает всё сам, с шифрованием. Ни текста, ни отправителя в сигнале нет. Выключите — и закрытое приложение ничего не получит до следующего запуска.',
  'web.notifyTitle': 'Уведомления в браузере',
  'web.notifyHint': 'Звонки и сообщения — даже когда вкладка Pine закрыта',
  'web.notifyBlocked': 'Запрещены в браузере',
  'web.notifyOn': 'Уведомления включены',
  'web.notifyBanner': 'Включите уведомления — иначе закрытая вкладка не узнает о звонке.',
  'web.notifyInstall': 'На iPhone уведомления приходят только в Pine на экране «Домой»: «Поделиться» → «На экран „Домой“», затем откройте Pine оттуда.',
  'web.installRelogin': 'Там нужно будет войти ещё раз: Safari и значок на экране «Домой» хранят данные раздельно. В Pine на значке нажмите «Войти по QR с другого устройства», скопируйте код и вставьте его здесь: Настройки → Устройства → «Добавить устройство».',
  'keysave.save': 'Сохранить ключ в браузере',
  'keysave.signIn': 'Войти ключом из браузера',
  'keysave.fill': 'Взять ключ из браузера',
  'settings.bgNotifications': 'Уведомления',
  'settings.bgBattery': 'Без ограничений батареи',
  'settings.bgFullScreen': 'Звонок на весь экран',
  'settings.bgAllowed': 'Разрешено',
  'settings.bgFix': 'Разрешить',
  'settings.bgUnrestricted': 'Работа в фоне не ограничена',
  'settings.bgJournal': 'Журнал работы в фоне',
  'settings.bgJournalHint': 'Если звонок не дошёл, отправьте журнал разработчику. В нём только время событий, без содержимого сообщений.',
  'settings.bgJournalSend': 'Отправить',
  'settings.network': 'Сеть',
  'settings.connection': 'Соединение',
  'settings.peers': 'Пиров подключено',
  'settings.mode': 'Режим',
  'settings.modeNative': 'Прямое P2P',
  'settings.modeRelay': 'Через релей',
  'settings.account': 'Профиль и ключи',
  'settings.recoveryKey': 'Ключ восстановления',
  'settings.showKey': 'Показать ключ',
  'settings.hideKey': 'Скрыть',
  'settings.storage': 'Хранилище',
  'settings.about': 'О программе',
  'settings.signOut': 'Выйти из аккаунта',
  'settings.signOutHint': 'Стереть аккаунт с этого устройства',
  'settings.signOutConfirm': 'Выйти и стереть',
  'settings.signOutWarning': 'Аккаунт Pine хранится только на этом устройстве — сервера с ним нет. Выход сотрёт профиль, чаты и настройки. Вернуться в этот аккаунт можно будет только по ключу восстановления.',
  'settings.signOutCopyKey': 'Скопировать ключ восстановления',
  'settings.signOutNeedKey': 'Скопируйте ключ, чтобы продолжить.',
  'update.title': 'Доступна версия {version}',
  'update.sub': 'Обновление ставится вручную — со страницы загрузок.',
  'update.action': 'Обновить',
  'settings.save': 'Сохранить',
  'settings.saved': 'Сохранено',

  'contacts.title': 'Контакты',
  'contacts.empty': 'Контактов пока нет',
  'contacts.emptyHint': 'Добавьте человека по его Pine ID, и вы сможете начать чат.',
  'contacts.add': 'Добавить контакт',
  'contacts.requests': 'Запросы',
  'contacts.accept': 'Принять',
  'contacts.decline': 'Отклонить',
  'contacts.block': 'Заблокировать',
  'contacts.unblock': 'Разблокировать',
  'contacts.blocked': 'Заблокирован',
  'block.sub': 'Не показывать его сообщения, запросы, звонки и истории',
  'block.blockedSub': 'Его новые сообщения, звонки и истории не показываются',
  'block.confirm': 'Pine перестанет показывать новые сообщения, запросы и звонки от {name}, не покажет его истории и не отправит ему ваши. Он об этом не узнает. Снять блокировку можно в любой момент.',
  'block.done': '{name} заблокирован',
  'block.undone': '{name} разблокирован',
  'block.inChat': 'Вы заблокировали этого человека. Его новые сообщения не показываются.',
  'contacts.message': 'Написать',
  'contacts.request': 'хочет начать чат',

  'call.incoming': 'Входящий звонок',
  'call.incomingVideo': 'Входящий видеозвонок',
  'call.calling': 'Вызов…',
  'call.connecting': 'Соединение…',
  'call.accept': 'Принять',
  'call.decline': 'Отклонить',
  'call.hangUp': 'Завершить',
  'call.joining': 'Подключаемся к звонку…',
  'call.participants': 'участников: {n}',
  'call.full': 'В звонке уже максимум участников',
  'call.unreachable': 'Не удалось соединить звонок. Похоже, сеть одной из сторон не пропускает звонки: попробуйте другую сеть или VPN.',
  'call.mute': 'Микрофон',
  'call.camera': 'Камера',
  'call.screen': 'Экран',
  'call.speaker': 'Динамик',
  'call.speakerOn': 'Громкая связь включена',
  'call.speakerOff': 'Включить громкую связь',
  'call.flip': 'Другая камера',
  'call.minimize': 'Свернуть звонок',
  'call.audioOutput': 'Звук',
  'call.route.auto': 'Автоматически',
  'call.route.earpiece': 'Динамик телефона',
  'call.route.speaker': 'Громкая связь',
  'call.route.bluetooth': 'Bluetooth',
  'call.route.wired': 'Проводные наушники',
  'call.ended': 'Звонок завершён',
  'call.unsupported': 'Звонки недоступны в этой среде',

  'status.online': 'В сети',
  'status.connecting': 'Подключение…',
  'status.reconnecting': 'Переподключение…',
  'status.offline': 'Нет сети',

  'time.now': 'только что',
  'time.yesterday': 'вчера',
  'time.today': 'Сегодня',
  'time.yesterdayFull': 'Вчера',

  'err.generic': 'Что-то пошло не так',
  'err.invite': 'Не удалось разобрать приглашение',
  'err.joinTimeout': 'Никого нет в сети, чтобы впустить вас. Попросите участника открыть Pine.',
  'err.noPeer': 'Не удалось связаться. Собеседнику нужно открыть Pine.',
  'err.needName': 'Введите имя',

  'action.copy': 'Копировать',
  'action.copied': 'Скопировано',
  'action.share': 'Поделиться',
  'action.done': 'Готово',
  'action.cancel': 'Отмена',
  'action.close': 'Закрыть',
  'action.retry': 'Повторить',
  'action.download': 'Скачать',
  'action.confirm': 'Подтвердить'
}

const en = {
  'app.name': 'Pine',
  'app.tagline': 'A messenger with no servers',
  'nav.chats': 'Chats',
  'nav.channels': 'Channels',
  'nav.contacts': 'Contacts',
  'nav.settings': 'Settings',

  'onboard.welcome': 'Welcome to Pine',
  'onboard.lede': 'Messages go straight between devices. No account, no phone number, and no server holding your conversations.',
  'onboard.create': 'Create a profile',
  'onboard.restore': 'I have a recovery key',
  'onboard.name': 'What should people call you?',
  'onboard.namePlaceholder': 'Name or nickname',
  'onboard.username': 'Pick a username',
  'onboard.usernameLede': 'It is how people find you without swapping long keys. You can skip this and set one later.',
  'onboard.usernameSkip': 'Skip',
  'access.title': 'One last thing: permissions',
  'access.lede': 'Android puts apps it is not looking at to sleep. Without these, calls and messages only arrive while Pine is open on screen.',
  'access.notifications': 'Notifications',
  'access.notificationsWhy': 'Otherwise nothing can tell you about a call or a message',
  'access.battery': 'Running in the background',
  'access.batteryWhy': 'Exempt from battery optimisation — without it the connection drops after a few minutes',
  'access.fullScreen': 'Full-screen calls',
  'access.fullScreenWhy': 'So an incoming call shows over the lock screen',
  'access.allow': 'Allow',
  'access.done': 'Done',
  'access.anyway': 'Continue without it',
  'access.needNotifications': 'Notifications are required to go on: without them the app cannot tell you about a call.',
  'access.partial': 'Some permissions are missing — calls may not arrive while the app is closed. You can grant them later in Settings.',
  'onboard.continue': 'Continue',
  'onboard.keyTitle': 'Save your recovery key',
  'onboard.keyLede': 'This is the only way back into your profile on another device. Nobody can reset it — there is no server holding a copy.',
  'onboard.keyCopied': 'Recovery key copied',
  'onboard.keySaved': 'I saved it',
  'onboard.restoreTitle': 'Restore your profile',
  'onboard.restoreLede': 'Enter the recovery key you saved when you created the profile.',
  'onboard.restoreAction': 'Restore',
  'onboard.back': 'Back',

  'chats.title': 'Chats',
  'chats.search': 'Search',
  'chats.empty': 'Nothing here yet',
  'chats.emptyHint': 'Start a group, a channel, or a direct chat with a Pine ID.',
  'chats.all': 'All',
  'chats.unread': 'Unread',
  'chats.groups': 'Groups',
  'chats.channels': 'Channels',
  'chats.direct': 'Direct',
  'chats.archived': 'Archived',
  'chats.saved': 'Saved',
  'restore.title': 'The messages are not loaded yet',
  'link.addDevice': 'Sign in with a QR from another device',
  'link.title': 'Sign in with a QR',
  'link.lede': 'On a device where you are already signed in, open Settings → Devices → Add device, and scan this code.',
  'link.orCode': 'Or copy the code and paste it there:',
  'link.waiting': 'Waiting for confirmation…',
  'link.expired': 'That code expired. Try again.',
  'devices.title': 'Devices',
  'devices.empty': 'Only this device so far.',
  'devices.unnamed': 'Device',
  'devices.current': 'this device',
  'devices.revoke': 'Unlink',
  'devices.revoked': 'Device unlinked',
  'devices.add': 'Add a device',
  'devices.addHint': 'Scan the QR shown on the new device',
  'devices.addAction': 'Continue',
  'devices.scanLede': 'Point the camera at the QR the new device is showing.',
  'devices.pasteLabel': 'Or paste the code from that device',
  'devices.linked': 'Device added',
  'devices.linking': 'Sending…',
  'devices.confirmTitle': 'Hand this account to that device?',
  'devices.confirmBody': 'It will have full access to your account and everything in it. Only do this if the device is yours and it is the one showing the code.',
  'devices.confirmAction': 'Hand it over',
  'devices.warning': 'Unlinking removes a device from the list, and an honest client signs itself out. It already holds the account key, though — if a device is in someone else’s hands, only a new account really takes it back.',
  'restore.action': 'Restore',
  'restore.asking': 'Asking the members…',
  'restore.asked': 'Asked {n}',
  'restore.nobodyOnline': 'None of the members are online. Try again later.',
  'restore.hint': 'The title and members came from the server. The messages come from the members themselves.',
  'restore.section': 'Restore',
  'restore.sectionHint': 'Ask the members for what this device is missing: the history, or the right to write.',
  'restore.nothingMissing': 'Nothing is missing from this chat',
  'attach.title': 'Attach',
  'attach.media': 'Photos and video',
  'attach.music': 'Music',
  'attach.documents': 'Documents',
  'attach.files': 'Files',
  'attach.poll': 'Poll',
  'attach.unreadable': 'Could not read {n} of the files',
  'attach.pickerFailed': 'Could not open the file picker',
  'poll.title': 'New poll',
  'poll.question': 'Question',
  'poll.questionPlaceholder': 'What are you asking?',
  'poll.options': 'Answers',
  'poll.optionPlaceholder': 'Answer',
  'poll.optionMore': 'Add an answer',
  'poll.optionsHint': 'A new row appears as you go. Enter moves to the next one.',
  'poll.limit': 'That is as many answers as a poll can have.',
  'poll.anonymous': 'Anonymous voting',
  'poll.multiple': 'Multiple answers',
  'poll.anonymousNote': 'Anonymous poll',
  'poll.noVotes': 'No votes yet',
  'poll.create': 'Create',
  'chats.you': 'You',
  'chats.draft': 'Draft',

  'new.title': 'New chat',
  'new.group': 'Group',
  'new.groupHint': 'A shared conversation everyone can post in',
  'new.channel': 'Channel',
  'new.channelHint': 'Admins publish, everyone else reads',
  'new.direct': 'Direct chat',
  'new.directHint': 'One to one, by Pine ID',
  'new.join': 'Join with a link',
  'new.joinHint': 'Paste an invite',
  'new.name': 'Name',
  'new.namePlaceholder': 'For example, Pine team',
  'new.description': 'Description',
  'new.create': 'Create',
  'new.peerId': 'Their Pine ID',
  'new.start': 'Start',
  'new.invitePlaceholder': 'https://papi.olshub.xyz/i/… or a code',

  'conv.placeholder': 'Message',
  'conv.placeholderChannel': 'Post to channel',
  'conv.readOnly': 'Only admins can post here',
  'conv.notWritable': 'Waiting for write access to this room…',
  'conv.askAccess': 'Ask again',
  'conv.queueing': 'The chat is still confirming this device. Go ahead and write: your messages go out as soon as someone in it is online.',
  'settings.contactDev': 'Contact the developer',
  'settings.contactDevHint': 'Questions, bugs, ideas',
  'contactDev.lede': 'Questions, bugs and ideas — email the developer:',
  'contactDev.copy': 'Copy address',
  'contactDev.write': 'Write an email',
  'stories.mute': 'Mute',
  'stories.unmute': 'Unmute',
  'conv.sending': 'Sending…',
  'bot.label': 'bot',
  'bot.start': 'Start',
  'bot.commands': 'Bot commands',
  'bot.addToGroup': 'Add to a group',
  'bot.addTitle': 'Add {name} to a group',
  'bot.add': 'Add',
  'bot.added': 'Invitation to “{name}” sent',
  'bot.addFailed': 'Not delivered: they are offline right now. You can send an invite link instead.',
  'bot.noGroups': 'No groups you can invite to',
  'assistant.subtitle': 'AI assistant',
  'assistant.denied': 'To use the AI assistant, please contact the developer.',
  'assistant.copyId': 'Copy my Pine ID',
  'assistant.idCopied': 'Pine ID copied — send it to the developer',
  'assistant.connecting': 'Anya is joining — the chat will be ready in a few seconds.',
  'action.send': 'Send',
  'stories.me': 'Me',
  'stories.mine': 'My story',
  'stories.add': 'Add a story',
  'stories.title': 'New story',
  'stories.caption': 'Caption — optional',
  'stories.publish': 'Post',
  'stories.published': 'Story posted for 24 hours',
  'stories.failed': 'Could not post',
  'stories.audience': 'Everyone you have a one-to-one chat with will see it. It disappears after 24 hours. The Pine server only ever holds it encrypted.',
  'stories.tooBig': 'That file is too big: stories take up to 24 MB',
  'stories.tooLong': 'A story video can be up to one minute long',
  'stories.unsupported': 'A story can be a photo or a video',
  'stories.unreadable': 'Could not open this photo',
  'stories.reply': 'Reply…',
  'stories.sent': 'Sent to your chat',
  'stories.play': 'Play',
  'stories.pause': 'Pause',
  'stories.gone': 'This story is no longer available',
  'stories.viewsTitle': 'Views: {n}',
  'stories.noViews': 'Nobody has watched it yet',
  'stories.delete': 'Delete',
  'stories.deleteConfirm': 'Delete this story for everyone?',
  'stories.deleted': 'Story deleted',
  'stories.replyHeader': 'Reply to a story',
  'stories.reactedHeader': 'Reacted to a story',
  'badge.bot': 'Bot',
  'contacts.inviteTo': 'invites you to “{name}”',
  'conv.empty': 'No messages yet',
  'conv.emptyHint': 'Send the first one — it goes straight to the other members.',
  'conv.awaitingPeer': 'The invite is on its way. {name} will see this chat when they open Pine — you can write now.',
  'conv.thatPerson': 'They',
  'conv.selectChat': 'Pick a chat',
  'conv.selectChatHint': 'Or start a new one with the “+” above the chat list.',
  'chats.noMessages': 'No messages yet',
  'conv.edited': 'edited',
  'conv.deleted': 'Message deleted',
  'conv.attachmentGone': 'Nobody online has this file any more',
  'media.loading': 'Loading…',
  'media.waiting': 'Will arrive once the sender is online',
  'media.tapToLoad': 'Tap to download',
  'invite.group': 'Group invite',
  'invite.channel': 'Channel invite',
  'invite.unnamed': 'Untitled',
  'invite.join': 'Join',
  'invite.subscribe': 'Subscribe',
  'collect.title': 'Collectible username',
  'collect.kind': 'Issued by the Pine operator · never expires',
  'collect.explain': 'It becomes your username. It never needs renewing, and nobody else can take it.',
  'collect.replaces': 'Your current name {name} will be released.',
  'collect.take': 'Take the name',
  'collect.done': 'You are now {name}',
  'collect.err.used': 'This link has already been used.',
  'collect.err.unknown': 'The link is not valid, or the name server is unreachable.',
  'collect.err.taken': 'That name is already taken.',
  'collect.err.frozen': 'This account is frozen and cannot take a name.',
  'collect.err.offline': 'Cannot reach the name server. Try again later.',
  'collect.err.failed': 'Could not take the name.',
  'settings.linkPreviews': 'Link previews',
  'settings.linkPreviewsHint': 'A link\'s title and picture in the message. The Pine server fetches the page — it learns the address, not the chat or the recipient.',
  'conv.reply': 'Reply',
  'conv.edit': 'Edit',
  'conv.delete': 'Delete',
  'conv.copy': 'Copy text',
  'conv.forward': 'Forward',
  'conv.pin': 'Pin',
  'conv.unpin': 'Unpin',
  'conv.replyTo': 'Replying to',
  'conv.editing': 'Editing',
  'conv.pinned': 'Pinned',
  'conv.jumpToLatest': 'Jump to latest',
  'conv.loadOlder': 'Load earlier messages',
  'conv.deleteConfirm': 'Delete this message for everyone?',
  'conv.deleteForAll': 'Delete for everyone',
  'conv.cancel': 'Cancel',
  'conv.typing': 'typing…',
  'conv.typingMany': 'are typing…',
  'conv.online': 'online',
  'conv.membersOnline': '{online} online',
  'conv.recording': 'Recording voice message',
  'emoji.search': 'Search emoji',
  'emoji.none': 'Nothing found',
  'emoji.cat.recent': 'Recently used',
  'emoji.cat.smileys': 'Smileys & emotion',
  'emoji.cat.people': 'People & body',
  'emoji.cat.nature': 'Animals & nature',
  'emoji.cat.food': 'Food & drink',
  'emoji.cat.travel': 'Travel & places',
  'emoji.cat.activities': 'Activities',
  'emoji.cat.objects': 'Objects',
  'emoji.cat.symbols': 'Symbols',
  'conv.slideToCancel': 'Release to send',

  'sys.join': '{name} joined',
  'sys.leave': '{name} left',
  'sys.kick': '{name} was removed',
  'sys.role': '{name} is now {role}',
  'sys.callEnded': 'Call, {duration}',
  'sys.callMissed': 'Missed call',
  'sys.callNoAnswer': 'Call, no answer',
  'sys.callDeclined': 'Call declined',

  'panel.info': 'Info',
  'panel.members': 'Members',
  'panel.media': 'Media',
  'panel.files': 'Files',
  'panel.links': 'Links',
  'panel.invite': 'Invite',
  'panel.inviteLink': 'Invite link',
  'panel.newInvite': 'Create a link',
  'panel.copyLink': 'Copy link',
  'panel.revoke': 'Revoke',
  'panel.notifications': 'Notifications',
  'panel.mute': 'Mute',
  'panel.pinChat': 'Pin chat',
  'panel.archive': 'Archive',
  'panel.leave': 'Leave chat',
  'panel.leaveConfirm': 'Leave this chat? History stays on this device.',
  'panel.permissions': 'Permissions',
  'panel.readOnly': 'Read only',
  'panel.membersCanInvite': 'Members can invite',
  'panel.reactions': 'Reactions',
  'panel.disappearing': 'Disappearing messages',
  'panel.noMedia': 'No media yet',
  'panel.makeAdmin': 'Make admin',
  'panel.makeModerator': 'Make moderator',
  'panel.makeMember': 'Make member',
  'panel.removeMember': 'Remove from chat',
  'panel.copyId': 'Copy Pine ID',

  'role.owner': 'Owner',
  'role.admin': 'Admin',
  'role.moderator': 'Moderator',
  'role.member': 'Member',
  'role.restricted': 'Restricted',

  'frozen.title': 'This account is frozen.',
  'frozen.body': 'The operator has restricted it: you cannot start or join new chats, and nobody can find you. Every chat you already have works as usual.',
  'frozen.self': 'This account is frozen: it cannot start new chats. Existing ones still work.',
  'frozen.peer': 'That account is frozen — a new chat with it cannot be started.',

  'report.title': 'Report',
  'report.action': 'Report',
  'report.user': 'Report this person',
  'report.userSub': 'The conversation is sent to support',
  'report.reason': 'Reason',
  'report.reason.spam': 'Spam',
  'report.reason.abuse': 'Abuse or threats',
  'report.reason.fraud': 'Fraud',
  'report.reason.illegal': 'Illegal content',
  'report.reason.other': 'Something else',
  'report.note': 'What happened',
  'report.notePlaceholder': 'Optional, but it helps',
  'report.send': 'Send the report',
  'report.sent': 'Report sent',
  'report.failed': 'The report could not be sent. Try again later.',
  'report.sendsMessage': 'This message, your Pine ID and the reason are sent to the server — nothing else.',
  'report.sendsChat': 'The last 100 messages of this chat are sent to the server in plain text, where the operator can read them. Nobody but the people in a Pine chat can normally see it — this is the one exception, and it only happens when you press this button.',

  'settings.title': 'Settings',
  'settings.profile': 'Profile',
  'avatar.change': 'Change photo',
  'avatar.remove': 'Remove photo',
  'avatar.updated': 'Photo updated',
  'avatar.failed': 'Could not process that image',
  'avatar.notImage': 'That is not an image',
  'badge.verified': 'Verified account',
  'badge.tester': 'Beta tester',
  'badge.donor': 'Supported the project',
  'badge.translator': 'Translator',
  'settings.badges': 'Badges',
  'settings.badgeAlways': 'Always shown',
  'settings.badgesHint': 'Badges appear next to your name for other people. They are handed out by whoever runs the server; you can switch any of them off except verification — which exists so nobody can pass themselves off as you.',
  'settings.badgeFailed': 'Could not save — the server is unreachable',
  'settings.badgeRefused': 'Could not save: the server refused the request',
  'settings.name': 'Name',
  'settings.bio': 'About',
  'settings.username': 'Username',
  'settings.usernameHint': 'People can find you by @name instead of a long ID.',
  'settings.usernamePlaceholder': 'for example, alex',
  'settings.usernameFree': 'Announced on the network',
  'settings.usernameNone': 'Not set',
  'name.err.emoji': 'Emoji are not allowed in a name',
  'username.err.short': 'At least 3 characters',
  'username.err.long': 'At most 32 characters',
  'username.err.charset': 'Latin letters, digits and underscore only',
  'username.err.underscore': 'Cannot start or end with an underscore',
  'username.err.empty': 'Enter a name',
  'username.err.taken': 'That name is taken — try another',
  'username.err.offline': 'The name server is unreachable. Try again later.',
  'username.err.failed': 'Could not claim that name',
  'username.err.stale': 'This device’s clock is wrong — check the time',
  'username.err.slow_down': 'Too many attempts. Wait a minute.',
  'settings.usernameTaken': 'Taken',
  'settings.usernameChecking': 'Checking…',
  'settings.usernameReserved': 'Reserved for you',
  'search.byUsername': 'Search by @name or Pine ID',
  'search.searching': 'Searching…',
  'search.notFound': 'Nobody is answering to that name. They may be offline.',
  'search.found': 'Found',
  'search.collision': 'Several people announced this name. Check the IDs.',
  'search.hint': 'A name belongs to one person. If the name server is unreachable, the search falls back to the network and may find several.',
  'contacts.username': 'Username',
  'settings.yourId': 'Your Pine ID',
  'settings.idHint': 'Give this to anyone who wants to message you.',
  'settings.appearance': 'Appearance',
  'settings.theme': 'Theme',
  'settings.themeSystem': 'Match system',
  'settings.themeLight': 'Light',
  'settings.themeDark': 'Dark',
  'settings.language': 'Language',
  'settings.notifications': 'Notifications',
  'settings.notificationsGroup': 'Notifications and sounds',
  'settings.chatsGroup': 'Chats and media',
  'settings.keysGroup': 'Key and sign-out',
  'settings.notificationsCalls': 'Notifications and calls',
  'settings.chatsAppearance': 'Chats and appearance',
  'settings.privacySecurity': 'Privacy and security',
  'settings.bgAttention': 'Calls may not reach you: check the permissions',
  'settings.notificationsOn': 'Show notifications',
  'settings.sound': 'Sound',
  'settings.autostart': 'Start with the computer',
  'settings.autostartHint': 'A computer cannot be woken by the server the way a phone can: messages and calls arrive only while Pine is running. It starts in the tray, without a window.',
  'settings.privacy': 'Privacy',
  'settings.readReceipts': 'Read receipts',
  'settings.typingIndicators': 'Share typing status',
  'settings.enterToSend': 'Enter sends the message',
  'settings.autoDownload': 'Auto-download media',
  'settings.backupKeys': 'Back up the chats',
  'settings.backupKeysHint': 'The chat keys are stored on the server encrypted, so a new device has its chats at once. Turn it off to ask the other members for them instead.',
  'settings.calls': 'Calls',
  'settings.telecom': 'Android system calling',
  'settings.telecomHint': 'Calls go through the phone\'s own calling service: they arrive more reliably and can be answered from a headset or a car. Turn it off if your phone misbehaves with it.',
  'pro.home': 'More models and higher limits for Anya',
  'pro.active': 'Active until {date}',
  'pro.ended': 'Ended {date}',
  'pro.inactive': 'Not active',
  'pro.unavailable': 'The server is not answering right now, try again later',
  'pro.what': 'What it gives',
  'pro.plain': 'Standard',
  'pro.perDay': 'Questions a day',
  'pro.perMonth': 'Questions a month',
  'pro.images': 'Pictures a day',
  'pro.models': 'Extra models',
  'pro.get': 'Get it',
  'pro.extend': 'Extend',
  'pro.howTo': 'The developer sets the subscription up. Press the button: the letter already carries your Pine ID. You will be told how to pay, and Pro is switched on.',
  'pro.contactLede': 'Write to the developer that you would like Pine AI Pro. You will be told how to pay, and the subscription is switched on for your Pine ID.',
  'pro.contactBody': 'Hello! I would like Pine AI Pro.',
  'settings.ringFromPush': 'Ring straight from the server',
  'settings.ringFromPushHint': 'The phone rings as soon as the server passes the call on, without waiting to connect to the caller. The server and Google then see who is calling you (the ID only, never the call).',
  'settings.ringtone': 'Ringtone',
  'settings.ringtonePine': 'Pine',
  'settings.ringtoneSystem': 'Same as the phone',
  'settings.ringtonePick': 'Choose on the phone…',
  'settings.background': 'Running in the background',
  'settings.backgroundHint': 'Calls and messages only arrive while Pine is running in the background. If any of these is not allowed, incoming ones may not reach you.',
  'settings.push': 'Wake Pine when it is closed',
  'settings.pushHint': 'The server sends an empty signal through Google — "a call" or "something new" — and Pine wakes up and fetches everything itself, encrypted. The signal carries no text and no sender. Turn it off and a closed app receives nothing until it is opened again.',
  'web.notifyTitle': 'Browser notifications',
  'web.notifyHint': 'Calls and messages — even with the Pine tab closed',
  'web.notifyBlocked': 'Blocked in the browser',
  'web.notifyOn': 'Notifications are on',
  'web.notifyBanner': 'Turn notifications on — otherwise a closed tab never hears about a call.',
  'web.notifyInstall': 'On iPhone, notifications only reach Pine on the Home Screen: Share → Add to Home Screen, then open Pine from there.',
  'web.installRelogin': 'You will need to sign in there once more: Safari and the Home Screen icon keep separate storage. In Pine on the icon, choose “Sign in with a QR from another device”, copy the code and paste it here: Settings → Devices → “Add a device”.',
  'keysave.save': 'Save the key in the browser',
  'keysave.signIn': 'Sign in with the saved key',
  'keysave.fill': 'Use the key saved in the browser',
  'settings.bgNotifications': 'Notifications',
  'settings.bgBattery': 'No battery restrictions',
  'settings.bgFullScreen': 'Full-screen calls',
  'settings.bgAllowed': 'Allowed',
  'settings.bgFix': 'Allow',
  'settings.bgUnrestricted': 'Background activity not restricted',
  'settings.bgJournal': 'Background journal',
  'settings.bgJournalHint': 'If a call did not come through, send the journal to the developer. It holds the times of events, nothing you wrote.',
  'settings.bgJournalSend': 'Send',
  'settings.network': 'Network',
  'settings.connection': 'Connection',
  'settings.peers': 'Peers connected',
  'settings.mode': 'Mode',
  'settings.modeNative': 'Direct peer to peer',
  'settings.modeRelay': 'Through a relay',
  'settings.account': 'Profile and keys',
  'settings.recoveryKey': 'Recovery key',
  'settings.showKey': 'Show key',
  'settings.hideKey': 'Hide',
  'settings.storage': 'Storage',
  'settings.about': 'About',
  'settings.signOut': 'Sign out',
  'settings.signOutHint': 'Erase this account from this device',
  'settings.signOutConfirm': 'Sign out and erase',
  'settings.signOutWarning': 'A Pine account lives only on this device — no server holds it. Signing out erases the profile, chats and settings. The recovery key is the only way back into this account.',
  'settings.signOutCopyKey': 'Copy the recovery key',
  'settings.signOutNeedKey': 'Copy the key to continue.',
  'update.title': 'Version {version} is available',
  'update.sub': 'Updating is manual — from the downloads page.',
  'update.action': 'Update',
  'settings.save': 'Save',
  'settings.saved': 'Saved',

  'contacts.title': 'Contacts',
  'contacts.empty': 'No contacts yet',
  'contacts.emptyHint': 'Add someone by their Pine ID to start a chat.',
  'contacts.add': 'Add contact',
  'contacts.requests': 'Requests',
  'contacts.accept': 'Accept',
  'contacts.decline': 'Decline',
  'contacts.block': 'Block',
  'contacts.unblock': 'Unblock',
  'contacts.blocked': 'Blocked',
  'block.sub': 'Stop showing their messages, requests, calls and stories',
  'block.blockedSub': 'Their new messages, calls and stories are not shown',
  'block.confirm': 'Pine will stop showing new messages, requests and calls from {name}, will hide their stories and stop sending them yours. They will not be told. You can unblock at any time.',
  'block.done': '{name} is blocked',
  'block.undone': '{name} is unblocked',
  'block.inChat': 'You blocked this person. Their new messages are not shown.',
  'contacts.message': 'Message',
  'contacts.request': 'wants to start a chat',

  'call.incoming': 'Incoming call',
  'call.incomingVideo': 'Incoming video call',
  'call.calling': 'Calling…',
  'call.connecting': 'Connecting…',
  'call.accept': 'Accept',
  'call.decline': 'Decline',
  'call.hangUp': 'Hang up',
  'call.joining': 'Joining the call…',
  'call.participants': '{n} in the call',
  'call.full': 'This call is already full',
  'call.unreachable': 'The call could not connect. One side\'s network seems to block calls: try another network or a VPN.',
  'call.mute': 'Mic',
  'call.camera': 'Camera',
  'call.screen': 'Screen',
  'call.speaker': 'Speaker',
  'call.speakerOn': 'Speakerphone is on',
  'call.speakerOff': 'Turn on the speakerphone',
  'call.flip': 'Switch camera',
  'call.minimize': 'Minimise the call',
  'call.audioOutput': 'Sound',
  'call.route.auto': 'Automatic',
  'call.route.earpiece': 'Phone earpiece',
  'call.route.speaker': 'Speakerphone',
  'call.route.bluetooth': 'Bluetooth',
  'call.route.wired': 'Wired headphones',
  'call.ended': 'Call ended',
  'call.unsupported': 'Calls are not available in this runtime',

  'status.online': 'Online',
  'status.connecting': 'Connecting…',
  'status.reconnecting': 'Reconnecting…',
  'status.offline': 'Offline',

  'time.now': 'just now',
  'time.yesterday': 'yesterday',
  'time.today': 'Today',
  'time.yesterdayFull': 'Yesterday',

  'err.generic': 'Something went wrong',
  'err.invite': 'That invite could not be read',
  'err.joinTimeout': 'Nobody is online to let you in. Ask a member to open Pine.',
  'err.noPeer': 'Could not reach them. They need Pine open.',
  'err.needName': 'Please enter a name',

  'action.copy': 'Copy',
  'action.copied': 'Copied',
  'action.share': 'Share',
  'action.done': 'Done',
  'action.cancel': 'Cancel',
  'action.close': 'Close',
  'action.retry': 'Retry',
  'action.download': 'Download',
  'action.confirm': 'Confirm'
}

const PLURALS = {
  ru: {
    members: { one: '{n} участник', few: '{n} участника', many: '{n} участников', other: '{n} участника' },
    messages: { one: '{n} сообщение', few: '{n} сообщения', many: '{n} сообщений', other: '{n} сообщения' },
    online: { one: '{n} в сети', few: '{n} в сети', many: '{n} в сети', other: '{n} в сети' },
    voted: {
      one: '{n} проголосовал',
      few: '{n} проголосовали',
      many: '{n} проголосовали',
      other: '{n} проголосовали'
    }
  },
  en: {
    members: { one: '{n} member', other: '{n} members' },
    messages: { one: '{n} message', other: '{n} messages' },
    online: { one: '{n} online', other: '{n} online' },
    voted: { one: '{n} vote', other: '{n} votes' }
  },
  tr: {
    members: { one: '{n} katılımcı', other: '{n} katılımcı' },
    messages: { one: '{n} mesaj', other: '{n} mesaj' },
    online: { one: '{n} çevrimiçi', other: '{n} çevrimiçi' },
    voted: { one: '{n} oy', other: '{n} oy' }
  },
  kk: {
    members: { one: '{n} қатысушы', other: '{n} қатысушы' },
    messages: { one: '{n} хабарлама', other: '{n} хабарлама' },
    online: { one: '{n} желіде', other: '{n} желіде' },
    voted: { one: '{n} дауыс', other: '{n} дауыс' }
  }
}

const BUNDLES = { ru, en, tr, kk }

export const LANGUAGES = [
  { code: 'ru', label: 'Русский' },
  { code: 'en', label: 'English' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'kk', label: 'Қазақша' }
]

let current = 'ru'
const listeners = new Set()

export function setLanguage (code) {
  current = BUNDLES[code] ? code : 'en'
  if (typeof document !== 'undefined') document.documentElement.lang = current
  for (const fn of listeners) fn(current)
}

export function getLanguage () {
  return current
}

export function onLanguageChange (fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function detectLanguage () {
  const nav = (typeof navigator !== 'undefined' ? (navigator.language || 'en') : 'en').toLowerCase()
  const match = LANGUAGES.find((language) => nav.startsWith(language.code))
  return match ? match.code : 'en'
}

/** t('conv.typing') — falls back to English, then to the key itself. */
export function t (key, vars = null) {
  const bundle = BUNDLES[current] || en
  let value = bundle[key]
  if (value === undefined) value = en[key]
  if (value === undefined) return key
  return vars ? interpolate(value, vars) : value
}

export function plural (kind, n) {
  const table = (PLURALS[current] || PLURALS.en)[kind]
  if (!table) return String(n)
  const rules = new Intl.PluralRules(current)
  const form = table[rules.select(n)] || table.other || table.one
  return interpolate(form, { n })
}

function interpolate (template, vars) {
  return template.replace(/\{(\w+)\}/g, (_, key) => (vars[key] === undefined ? '{' + key + '}' : vars[key]))
}
